<template>
  <div>
      <fill-tracker-fields
          ref="fillTrackerFields"
          v-on:saved="goToHomePage"
      >
      </fill-tracker-fields>
  </div>
</template>

<script>

import FillTrackerFields from "@/components/trackers/FillTrackerFields";

export default {
    components: {
        FillTrackerFields
    },

    mounted() {
        if (this.$route.query.fill_fields) {
            this.$refs.fillTrackerFields.open(this.$route.query.fill_fields)
        }
    },

    methods: {
        goToHomePage() {
            this.$router.push('public-trackers')
        }
    }
}
</script>
